import { competitiveAdvantages } from "@/mocks/homeData";

export default function CompetitiveSection() {
  return (
    <section id="competitive" className="relative w-full bg-white py-16 md:py-24">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-6xl mx-auto">
          <div className="animate-on-scroll text-center mb-12 md:mb-16">
            <p className="text-sky-500 text-sm font-semibold tracking-wider uppercase mb-3">
              Our Strengths
            </p>
            <h2 className="text-2xl md:text-4xl font-bold text-navy-900">
              경쟁력
            </h2>
            <p className="text-navy-500 text-sm md:text-base mt-3 max-w-xl mx-auto">
              글로벌 교류 플랫폼으로서의 핵심 경쟁력을 확인하세요
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5 md:gap-6">
            {competitiveAdvantages.map((item, index) => (
              <div
                key={index}
                className={`animate-on-scroll delay-${(index % 5) * 100 + 100} text-center p-5 md:p-6 rounded-xl bg-navy-50 hover:bg-sky-50 transition-colors duration-300`}
              >
                <div className="w-14 h-14 md:w-16 md:h-16 bg-white rounded-2xl flex items-center justify-center mx-auto mb-4 shadow-sm">
                  <div className="w-7 h-7 md:w-8 md:h-8 flex items-center justify-center">
                    <i className={`${item.icon} text-sky-500 text-xl md:text-2xl`} />
                  </div>
                </div>
                <h3 className="text-sm md:text-base font-bold text-navy-900 mb-2">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-navy-500 leading-relaxed">
                  {item.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}